import { render, staticRenderFns } from "./ChooseDepartments.vue?vue&type=template&id=2db2cf1d&"
import script from "./ChooseDepartments.vue?vue&type=script&lang=js&"
export * from "./ChooseDepartments.vue?vue&type=script&lang=js&"
import style0 from "./ChooseDepartments.vue?vue&type=style&index=0&id=2db2cf1d&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports